import { inject, Component, ElementRef, HostBinding, HostListener, Injectable, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import * as d3 from "d3";
import { axisTickFormat } from '../chart-axis-format';
import { FilterService } from 'src/app/services/filter.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from 'src/app/services/navigation.service';
import { RouterHandlerService } from 'src/app/services/router-handler.service';
import { CurrencyPipe } from '@angular/common';
import { NoDataNotifierService } from 'src/app/services/no-data-notifier.service';

@Injectable({
  providedIn: 'root'
})

@Component({
    selector: 'app-horizontal-bar-chart',
    templateUrl: './horizontal-bar-chart.component.html',
    styleUrls: ['./horizontal-bar-chart.component.scss'],
    standalone: false
})
export class horizontalHarChartComponent implements OnInit {
  private readonly noDataNotifier = inject(NoDataNotifierService);
  
  @ViewChild('wordCloudContainer', { static: true }) wordCloudContainer!: ElementRef;
  @ViewChild('WordCloudChart') WordCloudChart!: ElementRef;
  @ViewChild('fs') fs!: ElementRef;
  @HostBinding('class.is-fullscreen') isFullscreen = false;

  @Input('data') data: any;
  @Input('pageKey') pageKey: any;
  @Input('item') item: any;
  @Input('config') config: any;
  @Input('headerConfig') headerConfig: any;
  @Input('heading') heading: string = '';
  @Input('error_name') error_name: any;
  @Input('prefrenceConfig') prefrenceConfig: any;
  
  isActive = false;
  iconList: any[] = [];
  HbarChartData: any = [];
  props: any;
  divId: any = 'HbarChartDiv' // "WordCloudChartDiv";
  headerDivId: any = "HbarHeader";
  initiateChart: Boolean = false;
  noData: boolean = false;
  mytooltipData: any;
  dataTurn: any;
  tooltip: any;
  tooltipID: any = "d3WordCloudTooltip"
  tooltipType: any;
  clientKey: any;
  moduleKey: any;
  dashboardKey: any;
  cardName: any;
  cardId: any;
  moduleName: any;
  decryptedParams: any;
  subs: Subscription[] = [];
  isLoading = false;
  height: any;
  private handleRadius = 6;
  private currentMin = 0;
  private currentMax = 100;
  private margins = { left: 10, top: 20 }
  private orientation = 'horizontal';

  @HostListener('fullscreenchange', ['$event'])
  @HostListener('webkitfullscreenchange', ['$event'])
  @HostListener('mozfullscreenchange', ['$event'])
  @HostListener('MSFullscreenChange', ['$event'])
  screenChange(event: any) {
    if (!document.fullscreenElement) {
      this.closeFullscreen();
    }
  }
  
  constructor(
    private filterService: FilterService,
    private route: ActivatedRoute,
    private navigationService: NavigationService,
    private routerHandlerService: RouterHandlerService,
    private currency: CurrencyPipe
  ) {
    this.subs.push(
      this.filterService.filterQuery.subscribe((query: any) => {
        this.start();
      }))
    this.route.params.subscribe((p: any) => {
      this.moduleName = p['module'] || '';
      this.cardName = p['cardName'] || '';
      this.route.queryParams.subscribe((params: any) => {
        this.decryptedParams = this.navigationService.decryptData(params);
        this.clientKey = this.decryptedParams["cl_key"];
        this.moduleKey = this.decryptedParams["md_key"];
        this.dashboardKey = this.decryptedParams["ds_key"];
      });
    });
  }

  numbedPipe(value: any) {
    if(value==null || value==undefined || value=='' || value==0){return '';}
    return this.currency.transform(value, '', '', '1.0-2');
  }

  async stop(ms: number): Promise<void> {
    return new Promise<void>(resolve => setTimeout(resolve, ms));
  }

  start() { this.isLoading = true; }

 private NavigationArrow(myType: any, myData: any, myX: any, myY: any, chartWidth: any): void {
  
  const conf0 = this.item.config?.['nav_configuration'].controls[0]
    let nav = {
      dbJSON : conf0.dbJSON,
      s3JSON : conf0.s3JSON,
      pageName : conf0.s3JSON?.page_nm,
      isDashboardLevel : conf0.isDashboardLevel
    }
   
    let payload:any ={[conf0.payloadData]:conf0.payloadData=='column_key'? myData[0].AllData[0][conf0.payloadData] : myData[0].range }
    this.routerHandlerService.navDetailInfo(nav); 
    this.routerHandlerService.storingPayloadAndFilterForGrid(conf0, payload, this.cardName);
    let src_nm = '';
    let spltFlr = conf0.filterData.split(',')
    spltFlr.forEach((res:any) => {
    src_nm+=payload[res]
    })
    let query:any = Object.assign({}, this.decryptedParams, {tab_id: 0}, {page: 'card'},{ds_nm:src_nm});
    let queryMaped = this.navigationService.movePropertyToFirst(query, 'tab_id');
    this.navigationService.routerNavigate(`dashboard/${this.moduleName}/${nav.pageName}`, queryMaped);
  }

  private showTooltip(myType: any, myData: any, myX: any, myY: any, chartWidth: any, chartHeight: any): void {
    this.tooltipType = myType
    this.mytooltipData = this.tooltipType == 'groupHBar' ? myData : myData
    this.dataTurn = 0;
    this.height = 0;
    this.dataTurn = chartWidth - myX
    this.height = chartHeight - myY
    if (myType=='groupFullName') {
      d3.select(`#${this.tooltipID}`)
        .style('visibility', 'visible')
        .style('position', 'absolute')
        .style('top', (  myY + 40) + 'px')
        .style('left', (myX + 30) + 'px')
        .style('right', 'unset')
        .style('bottom', 'unset')
        return
    }
    if (this.height < 200) {
      d3.select(`#${this.tooltipID}`)
        .style('visibility', 'visible')
        .style('position', 'absolute')
        .style('bottom', (this.height - 60) + 'px')
        .style('top', 'unset')
    }
    else if (this.height > 200) {
      d3.select(`#${this.tooltipID}`)
        .style('visibility', 'visible')
        .style('position', 'absolute')
        .style('top', (myY + 30) + 'px')
        .style('bottom', 'unset')
    }
    if (this.dataTurn < 250) {
      d3.select(`#${this.tooltipID}`)
        .style('visibility', 'visible')
        .style('position', 'absolute')
        // .style('top', myY + 40 + 'px')
        .style('right', (this.dataTurn + 30) + 'px')
        .style('left', 'unset')
        // .style('bottom', 'unset')
    }
    else if (this.dataTurn > 250) {
      d3.select(`#${this.tooltipID}`)
        .style('visibility', 'visible')
        .style('position', 'absolute')
        // .style('top', (  myY + 40) + 'px')
        .style('left', (myX + 30) + 'px')
        .style('right', 'unset')
        // .style('bottom', 'unset')
    }
    this.tooltip = true;
  }

  private hideTooltip(myType: any): void {
    this.tooltip = false;
    d3.select(`#${this.tooltipID}`)
      .style('visibility', 'hidden');
  }

  ngOnInit(): void {
    this.divId = this.divId + this.item?.['config']?.list_of_api?.['api_key'];
    this.tooltipID = this.tooltipID + this.item?.['config']?.list_of_api?.['api_key'];
    this.start()
    this.iconList = this.item.config.icon ? this.item.config.icon : this.iconList
    this.initiateCharts();
    // this.getWordCloudData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']?.currentValue != changes['data']?.previousValue && this.initiateChart) {
      this.getWordCloudData();
    }

    // The preference and data APIs are requested in parallel, so preferences can resolve
    // after the chart has already been drawn with defaults. Re-apply them here so saved
    // preferences always render, whichever response lands first — getWordCloudData()
    // covers the other order by reading prefrenceConfig when it is already available.
    if (changes['prefrenceConfig'] &&
        changes['prefrenceConfig'].currentValue !== changes['prefrenceConfig'].previousValue &&
        Object.keys(changes['prefrenceConfig'].currentValue || {}).length > 0 &&
        this.HbarChartData?.length) {
      this.applyChartPreferences(changes['prefrenceConfig'].currentValue);
    }
  }

  closeFullscreen(): void {
    this.isFullscreen = false;
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }
    let cgf:any = this.item.config;
    this.props.chartHeight = cgf?.designer_chart_height ? Number(cgf?.designer_chart_height) : this.item.config?.y_axis_nav?.value == 'true' ? 500 : 500
    this.isActive = false;
    setTimeout(() => {
      this.plotChart()
    }, 100);
  }

  @HostListener("window:resize", ["$event"])
  onResize(event: Event) {
    setTimeout(() => {
      this.plotChart()
    }, 100);
  }

  // d3 chart initial structure
  async initiateCharts(): Promise<void> {
    // only need to call this once on initialisation
    const myChart = this;
    const myClass = myChart.divId;
    await document.fonts.ready;
    const mySvg = d3.select(this.wordCloudContainer.nativeElement)
      .append('svg')
      .attr('id', 'svg_' + myClass)
      .attr('width', '100%')
      .style('background-color', 'white');
    mySvg.append('g').attr('id', 'legendGroup' + myClass);
    mySvg.append('g').attr('id', 'resizeGroup' + myClass);
    mySvg.append('g').attr('id', 'brushBarGroup' + myClass);
    mySvg.append("g").attr("id", "brushGroup" + myClass);
    mySvg.append("g").attr("id", "chartGroup" + myClass);
    mySvg.append("g").attr("id", "xAxis" + myClass);
    mySvg.append('text').attr('id', 'xAxisLabel' + myClass);
    mySvg.append('text').attr('id', 'yAxisLabel' + myClass);
    mySvg.append('text').attr('id', 'noDataMessage' + myClass);
    const defs = mySvg.append('defs');
    defs.append('clipPath').attr('id', 'ghbBrushClip' + myClass)
      .append('rect').attr('id', 'ghbBrushClipRect' + myClass);
    defs.append('clipPath').attr('id', 'ghbtextClip' + myClass)
      .append('rect').attr('id', 'ghbtextClipRect' + myClass);
    defs.append('clipPath').attr('id', 'tghbtextClip' + myClass)
      .append('rect').attr('id', 'tghbtextClipRect' + myClass);
    defs.append('clipPath').attr('id', 'alcClip' + myClass)
      .append('rect').attr('id', 'alcClipRect' + myClass);
    const filter = defs.append('filter').attr('id', 'drop-shadow').attr('width', 10).attr('height', 24);
    filter.append('feGaussianBlur').attr('in', 'SourceAlpha').attr('stdDeviation', 1).attr('result', 'blur');
    filter.append('feOffset').attr('in', 'blur').attr('dx', 1)
      .attr('dy', 1).attr('result', 'offsetBlur');
    filter.append('feFlood').attr('in', 'offsetBlur')
      .attr('flood-color', '#000000').attr('flood-opacity', 0.4)
      .attr('result', 'offsetColor');
    filter.append('feComposite').attr('in', 'offsetColor').attr('in2', 'offsetBlur').attr('operator', 'in').attr('result', 'offsetBlur');
    const feMerge = filter.append('feMerge');
    feMerge.append('feMergeNode').attr('in', 'offsetBlur');
    feMerge.append('feMergeNode').attr('in', 'SourceGraphic');
    mySvg.append('line').attr('class', 'handleLines' + myClass + ' handleLeftLine1' + myClass);
    mySvg.append('line').attr('class', 'handleLines' + myClass + ' handleLeftLine2' + myClass);
    mySvg.append('line').attr('class', 'handleLines' + myClass + ' handleRightLine1' + myClass);
    mySvg.append('line').attr('class', 'handleLines' + myClass + ' handleRightLine2' + myClass);
    mySvg.append('g').attr('id', 'sliderGroup' + myClass).attr('class', 'slider' + myClass);
    this.initiateChart = true
  }

  // chart svg  plotChart rendering 
  plotChart(): void {
    const myChart: any = this;
    const myClass = myChart.divId;
    const mySvg: any = d3.select('#svg_' + myClass);
    const width: any = mySvg.node().getBoundingClientRect().width;
    let height = myChart.props?.chartHeight < 300 ? 300 : myChart?.props?.chartHeight;
   const margins = {
      left: this.props.yAxisShow ? 20 : 40,
      right: 20,
      top: this.props.legendShow ? 30 : 10,
      bottom: this.props.xAxisShow ? 40 : 15,
      group: 4,
      brush: 52,
      mid: -18,
      dragX: this.isFullscreen ? 120 : 62,
      range: this.props.yAxisShow ? (this.isFullscreen ? 120 : 62) : 0
    };
    if (!this.props.legendShow) {
      margins.top = 10;
    }

    mySvg.attr("height", height);
    if (myChart.props.navArrow) {
      margins.range = myChart.isFullscreen ? 150 : (myChart.item?.config?.axis_nav_label ? Number(myChart.item?.config?.axis_nav_label) - 10 : 62),
        margins.dragX = myChart.isFullscreen ? 150 : (myChart.item?.config?.axis_nav_label ? Number(myChart.item?.config?.axis_nav_label) - 10 : 62),
        margins.brush = 52
    }
    if (myChart.item?.config?.axis_nav_label && myChart.item?.config?.axis_nav_label) {
        margins.range = (Number(myChart.item?.config?.axis_nav_label) - 10),
        margins.dragX = (Number(myChart.item?.config?.axis_nav_label) - 10),
        margins.brush = 52
    }
    margins.range = this.props.yAxisShow ? margins.range : 0
    // Bar Slider
    myChart.barMin = undefined;
    myChart.barMax = undefined;
    // Line Slider
    myChart.lineMin = undefined;
    myChart.lineMax = undefined;
    let rangeSet: any = new Set();
    let stackSet: any = Object.keys(myChart.props.barFill)
    let groupSet: any = new Set();
    myChart.HbarChartData.forEach((d: any) => {
      rangeSet.add(d[myChart.props.rangeVar]);
      groupSet.add(d[myChart.props.groupVar]);
    })
    stackSet = Array.from(stackSet);
    rangeSet = Array.from(rangeSet);
    groupSet = Array.from(groupSet);

    const firstGroup = Array.from(d3.group(myChart.HbarChartData, (d: any) => d[myChart.props.groupVar]));
    const stackData: any = [];
    firstGroup.forEach((d: any) => {
      rangeSet.forEach((r: any) => {
        const myStackObject: any = {
          groupVar: d[0],
          range: r,
          data: d
        }
        const matchingRows: any = d[1].filter((f: any) => f[myChart.props.groupVar] === d[0] && f[myChart.props.rangeVar] === r);
        stackSet.forEach((s: any) => {
          const myRange = matchingRows.find((f: any) => f[myChart.props.stackVar] === s);
          if (myRange === undefined) {
            myStackObject[s] = 0;
          } else {
            myStackObject[s] = +myRange[myChart.props.valueVar];
          }
        })
        stackData.push(myStackObject);
      })
    })

    const myStack = d3.stack()
      .keys(stackSet)
      .order(d3.stackOrderNone)
      .offset(d3.stackOffsetNone)
      (stackData);

    const allStack: any = [];
    myStack.forEach((d: any) => d.forEach((s: any) => {
      s["key"] = d.key;
      allStack.push(s)
    }));

    let groupedData: any = [];
    let xMax: any = d3.max(allStack, (m: any) => m[1]);
    groupSet.forEach((d: any, i: any) => {
      const myData = allStack.filter((f: any) => f.data.groupVar === d);
      let groupTotal = 0; // Calculate total for this group/bar
      // Calculate the total value for the entire bar (group)
      myData.forEach((segment:any) => {
        groupTotal += (segment[1] - segment[0]); // Add the value of this segment
      });

      const byRange: any = [];
      rangeSet.forEach((r: any) => {
        const rangeData = myData.filter((f: any) => f.data.range === r);
        // Calculate total for this specific range within the group
        let rangeTotal = 0;
        rangeData.forEach((segment:any) => {
          rangeTotal += (segment[1] - segment[0]);
        });

        const rangeWithPercentages = rangeData.map((segment:any) => {
          const segmentValue = segment[1] - segment[0];
          const percentage = groupTotal > 0 ? (segmentValue / groupTotal) * 100 : 0;
          return {
            ...segment,
            percentage: percentage,
            segmentValue: segmentValue // Add the segment value itself if needed elsewhere
          };
        });

        byRange.push({
          range: d, // Use 'd' which is the group variable name (for the y-axis label)
          rangeWithPercentages,
          rangeTotal: rangeTotal // Total value for this specific range within the group
        })
      })
      groupedData.push({
        group: d,
        data: byRange,
        groupIndex: i,
        maxVal: d3.max(myData, (m: any) => m[1]), // This is the max *end* value for the group's bar
        totalValue: groupTotal // Add the total value for the entire group/bar
      })
    })
    // --- END MODIFICATION ---

    let visibleGroups = 1;
    let chartWidth = width - margins.left - margins.brush - margins.mid - margins.range - 36 - 24 - margins.right;
    if (!this.props.yAxisShow) {
      chartWidth = width - margins.left - margins.brush - 24 - margins.mid- margins.range - 36 - margins.right;
    }
    let groupHeight = (15 * (rangeSet.length + 1)) + margins.group;
    let chartHeight = (groupHeight * groupSet.length) + margins.top + margins.bottom;
    if (!this.props.xAxisShow) {
      chartHeight = height - 10;
    }
    if (chartHeight < height) {
      // groupHeight = (height - margins.top - margins.bottom)/groupSet.length;
      //  chartHeight = (groupHeight * groupSet.length) + margins.top + margins.bottom;
    } else {
      //height = chartHeight;
      //mySvg.attr("height", chartHeight);
    }
    // Min Tick Count For avoiding the Format issue
    xMax = xMax > myChart.props.XtickCount ? xMax : myChart.props.XtickCount;
    xMax =  myChart.props.totalOntop ? (xMax * 1.2) : xMax;
    const yScaleAll: any = d3.scaleLinear().domain([0, groupSet.length]).range([0, height - margins.top - margins.bottom])
    const yScale: any = d3.scaleLinear().domain([0, groupSet.length]).range([0, height - margins.top - margins.bottom])
    const xScale: any = d3.scaleLinear().domain([0, xMax]).range([0, chartWidth]);
    const xScaleBrush: any = d3.scaleLinear().domain([0, xMax]).range([0, margins.brush - 2])
    const brushRangeHeight = ((height - margins.top - margins.bottom) / groupSet.length) / (rangeSet.length + 2) + 3;
    let startingVisibleGroups: any = parseInt(String((height - margins.top - margins.bottom) / groupHeight + 6));
    // console.log(startingVisibleGroups);
    startingVisibleGroups = startingVisibleGroups > groupSet.length ? groupSet.length : startingVisibleGroups;
    const brushStartY = groupSet.length === 0 ? 0 : (1 - (startingVisibleGroups / groupSet.length))
      * (height - margins.top - margins.bottom);
    groupHeight = (height - margins.top - margins.bottom) / startingVisibleGroups;
    let rangeHeight = (groupHeight * visibleGroups) / (rangeSet.length);
    const brush: any = d3.brushY()
      .handleSize(10)
      .extent([[0, 0], [margins.brush, height - margins.top - margins.bottom]])
      .on('start brush end', brushed);

    mySvg.select('#xAxis' + myClass)
      .attr("visibility", xMax === 0 ? "hidden" : "visible")
      // @ts-ignore
      // .call(d3.axisBottom(xScale).tickSizeOuter(0).ticks(myChart.props. XtickCount))
      .call(d3.axisBottom(xScale).tickSizeOuter(0).ticks(5).tickFormat((d: any) => axisTickFormat(myChart.props.xAxisFormatting)(d)))
      .attr('transform', 'translate(' + (width - chartWidth - margins.right) + ',' + (height - margins.bottom) + ')');

    mySvg.selectAll('#xAxis' + myClass + " text")
      .attr("font-family", "Poppins")
      .attr("font-weight", 700)
      .attr("font-size", 12)
      .attr("fill", "#101D42")

    mySvg.select('#xAxis' + myClass + " path")
      .attr("display", "none");

    mySvg.selectAll('#xAxis' + myClass + " line")
      .attr("y1", 0)
      .attr("y2", -(height - margins.top - margins.bottom))
      .style('stroke', '#E8EAEE')
      .style('stroke-width', '1');

    mySvg.select('#ghbBrushClipRect' + myClass)
      .style('width', width - margins.left - margins.right - margins.brush - margins.mid)
      .style('height', height - margins.top - margins.bottom)
      .attr('transform', 'translate(' + (margins.left + margins.brush + margins.mid) + ',' + margins.top + ')');

    mySvg.select('#ghbtextClipRect' + myClass)
      .style('width', chartWidth)
      .style('height', height - margins.top - margins.bottom)
      .attr('transform', 'translate( 0, -14 )');
       mySvg.select('#tghbtextClipRect' + myClass)
      .style('width', chartWidth)
      .style('height', height - margins.top - margins.bottom)
      .attr('transform', 'translate(' + (margins.left + margins.brush + margins.mid+ margins.range + margins.dragX) + ',' + margins.top + ')');

    // clip rect 
    mySvg.select('#alcClipRect' + myClass)
      .style('width', margins.brush)
      .style('height', height - margins.top - margins.bottom)
    // .attr('transform', 'translate('+ (margins.left) + ',' + margins.top + ')');

    // Step 2: Create the main group for the brush and apply the clip-path
    mySvg.selectAll('.brushChartGroup' + myClass).remove();
    const brushChartGroup = mySvg
      .select('#brushGroup' + myClass)
      .attr('clip-path', 'url(#alcClip' + myClass + ')') // Apply the clip-path to the group
      .attr('transform', 'translate(' + margins.left + ',' + margins.top + ')'); // Properly position the group

    // Step 3: Render the bars inside the brushChartGroup
    const brushGroupData = brushChartGroup.selectAll('.brushChartGroup' + myClass)
      .data(groupedData)
      .join((group: any) => {
        const enter = group.append('g').attr('class', 'brushChartGroup' + myClass);
        enter.append('g').attr('class', 'brushRangeGroup');
        return enter;
      });

    brushGroupData.select('.brushRangeGroup')
      .attr('transform', (d: any, i: any) => 'translate(0,' + (yScale(d.groupIndex) - 4) + ')');

    const brushRangeGroup = brushGroupData
      .select('.brushRangeGroup')
      .selectAll('.brushRangeGroup' + myClass)
      .data((d: any) => {
        d.data[0].rangeWithPercentages.map((m: any, i: any) => { // Use rangeWithPercentages
          const dataWidth = xScaleBrush(m[1]) - xScaleBrush(m[0]);
          m.width = dataWidth < 2 && dataWidth !== 0 ? 2 : dataWidth;
          if (dataWidth < 2 && i < (d.data.length - 1)) {
            d.data[0].rangeWithPercentages.filter((f: any, index: any) => index > i).forEach((m: any) => { // Use rangeWithPercentages
              m.extraX = dataWidth === 0 ? 0 : 2 - dataWidth;
            });
          }
        });
        d.data[0].rangeWithPercentages.map((m: any, i: any) => m.borderRadius = i === (d.data.length - 1) ? 0 : 0); // Use rangeWithPercentages
        return d.data[0].rangeWithPercentages; // Use rangeWithPercentages
      })
      .join((group: any) => {
        const enter = group.append('g').attr('class', 'brushRangeGroup' + myClass);
        enter.append('path').attr('class', 'brushRangeBar');
        return enter;
      });

    brushRangeGroup.select('.brushRangeBar')
      .attr('d', (d: any) => "M0,0 L"
        + (d.width - d.borderRadius) +
        ",0 Q" + d.width
        + ",0  " + d.width + "," + d.borderRadius + " L " + d.width
        + "," + (brushRangeHeight - d.borderRadius) + " Q " + d.width + "," + (brushRangeHeight) + " "
        + (d.width - d.borderRadius) +
        "," + (brushRangeHeight) + " L 0," + (brushRangeHeight) + " Z")
      .attr('transform', (d: any) => "translate(" + (xScaleBrush(d[0]) + (d.extraX === undefined ? 0 : d.extraX)) +
        ",12)")
      .attr('fill', (d: any) => myChart.props.barFill[d.key]);

    mySvg.select('#brushGroup' + myClass)
      .attr('transform', 'translate(' + margins.left + ',' + margins.top + ')')
      //@ts-ignore
      .call(brush)
      .call(brush.move, [0, (height - margins.top - margins.bottom) - brushStartY]);

    mySvg.selectAll('.handleLines' + myClass)
      .attr('visibility', myChart.HbarChartData.length === 0 ? 'hidden' : 'visible')
      .attr('x1', margins.left + (margins.brush - 12) / 2)
      .attr('x2', margins.left + 12 + (margins.brush - 12) / 2)
      .style('stroke', '#8A98AB')
      .style('stroke-width', '1')
      .attr('transform', 'translate(0,' + margins.top + ')');

    // axis labels
    mySvg.select('#xAxisLabel' + myClass)
      .attr('visibility',  myChart.props.xAxisShow ? 'visible' : 'hidden')
      .attr('x', margins.left + ((width - margins.left - margins.right) / 2))
      .attr('y', height)
      .attr('text-anchor', 'middle')
      .attr('font-family', 'Poppins')
      .attr('fill', '#737D88')
      .attr('font-size', '12px')
      // @ts-ignore
      .text(myChart.props.xAxisLabel);

    mySvg.select('#yAxisLabel' + myClass)
      .attr('visibility', myChart.props.yAxisShow ? 'visible' : 'hidden')
      .attr('transform', 'translate(10,' + (margins.top + ((height - margins.top - margins.bottom - margins.mid - margins.brush) / 2)) + ') rotate(-90)')
      .attr('text-anchor', 'middle')
      .attr('font-family', 'Poppins')
      .attr('fill', '#737D88')
      .attr('font-size', '12px')
      // @ts-ignore
      .text(myChart.props.yAxisLabel);

    mySvg.selectAll('#brushGroup' + myClass)
      .selectAll('.selection')
      .attr('fill', '#A0A0A0')
      .attr('fill-opacity', '0.09')
      .style('stroke', '#E8EAEE')
      .style('stroke-width', '1');

    const rectWidth = 4;
    const rectHeight = height - margins.top - margins.bottom;
    const startX = margins.left + margins.brush + margins.range + 39;
    const startY = margins.top;
    const borderRadius = 1.5; // Rounded corners
    const xDragMax = chartWidth - (myChart.isFullscreen ? 300 : 100);

    // Select or create the group
    let group = mySvg.select('#resizeGroup' + myClass);
    if (group.empty()) {
      group = mySvg.append("g").attr("id", 'resizeGroup' + myClass);
    }

    // Remove existing rectangle and dots before adding new ones
    group.selectAll('.resizeRect' + myClass).remove();

    // Create a new group for the draggable rectangle
    const rectGroup = group.append("g")
      .attr("class", 'resizeRect' + myClass)
      .attr("transform", `translate(${startX}, 0)`)
      .call(d3.drag()
        .on("drag", function (event) {
          let xPosition = event.x;
          if (xPosition > startX && xPosition < xDragMax) {
            d3.select(this).attr("transform", `translate(${xPosition}, 0)`);
            margins.range = margins.dragX + (xPosition - startX);
            console.log("Dragged value (X position): " + xPosition, margins.range);
            chartWidth = width - margins.left - margins.brush - margins.mid - margins.range - 36 - 24 - margins.right;
            // slider
            if (myChart.props.leftSlider) {
              myChart.barMin = myChart.currentMin;
              myChart.barMax = xMax;
              createRangeSlider('bar', myChart.currentMin, xMax);
            }
            drawChart();
          }
        })
      );

    // Create the rounded rectangle
    rectGroup.append("rect")
      .attr("x", -rectWidth / 2)
      .attr("y", startY)
      .attr("width", rectWidth)
      .attr("height", rectHeight)
      .attr("rx", borderRadius)
      .attr("ry", borderRadius)
      .attr("fill", "#fff")
      .style("cursor", "e-resize");

    drawLegend(Object.keys(myChart.props.barFill));
    drawChart();

    function drawChart() {
      const xScale: any = d3.scaleLinear().domain([myChart.barMin || 0, myChart.barMax || xMax]).range([0, chartWidth]);
      const xScaleBrush: any = d3.scaleLinear().domain([myChart.barMin || 0, myChart.barMax || xMax]).range([0, margins.brush - 2])

     mySvg.select('#xAxis' + myClass)
      .attr("visibility", myChart.props.xAxisShow ? "visible" : "hidden")
      .call(
        d3.axisBottom(xScale)
          .tickSizeOuter(0)
          .ticks(5)
          .tickFormat((d: any) => axisTickFormat(myChart.props.xAxisFormatting)(d))
      )
      .attr('transform',
        'translate(' +
        (width - chartWidth - margins.right) +
        ',' +
        (height - margins.bottom) +
        ')'
      );

  mySvg.selectAll('#xAxis' + myClass + " text")
    .attr("font-size", myChart.props.xAxisFontSize)
    .attr("fill", myChart.props.xAxisColor)
    .attr("font-weight", myChart.props.xAxisBold ? 700 : 400);



      mySvg.select('#xAxis' + myClass + " path")
        .style('stroke-width', '1')
        .style('stroke', '#E8EAEE')
      // .attr("display", "none");

      mySvg.selectAll('#xAxis' + myClass + " line")
        .attr("y1", 0)
        .attr("y2", -(height - margins.top - margins.bottom))
        .style('stroke', '#E8EAEE')
        .style('stroke-width', '1');

      const brushRangeGroup = brushGroupData
        .select('.brushRangeGroup')
        .selectAll('.brushRangeGroup' + myClass)
        .data((d: any) => {
          d.data[0].rangeWithPercentages.map((m: any, i: any) => { // Use rangeWithPercentages
            const dataWidth = xScaleBrush(m[1]) - xScaleBrush(m[0]);
            m.width = dataWidth < 2 && dataWidth !== 0 ? 2 : dataWidth;
            if (dataWidth < 2 && i < (d.data.length - 1)) {
              d.data[0].rangeWithPercentages.filter((f: any, index: any) => index > i).forEach((m: any) => { // Use rangeWithPercentages
                m.extraX = dataWidth === 0 ? 0 : 2 - dataWidth;
              });
            }
          });
          d.data[0].rangeWithPercentages.map((m: any, i: any) => m.borderRadius = i === (d.data.length - 1) ? 0 : 0); // Use rangeWithPercentages
          return d.data[0].rangeWithPercentages; // Use rangeWithPercentages
        })
        .join((group: any) => {
          const enter = group.append('g').attr('class', 'brushRangeGroup' + myClass);
          enter.append('path').attr('class', 'brushRangeBar');
          return enter;
        });

      brushRangeGroup.select('.brushRangeBar')
        .attr('d', (d: any) => "M0,0 L"
          + (d.width - d.borderRadius) +
          ",0 Q" + d.width
          + ",0  " + d.width + "," + d.borderRadius + " L " + d.width
          + "," + (brushRangeHeight - d.borderRadius) + " Q " + d.width + "," + (brushRangeHeight) + " "
          + (d.width - d.borderRadius) +
          "," + (brushRangeHeight) + " L 0," + (brushRangeHeight) + " Z")
        .attr('transform', (d: any) => "translate(" + (xScaleBrush(d[0]) + (d.extraX === undefined ? 0 : d.extraX)) +
          ",12)")
        .attr('fill', (d: any) => myChart.props.barFill[d.key]);

      groupHeight = (height - margins.top - margins.bottom) / visibleGroups;
      rangeHeight = groupHeight / (rangeSet.length + 2);
      mySvg.selectAll('#brushGroup' + myClass)
        .selectAll('.selection')
        .attr('fill', '#A0A0A0')
        .attr('fill-opacity', '0.09')
        .style('stroke', '#E8EAEE')
        .style('stroke-width', '1');

      mySvg.selectAll(".selection")
        .attr('visibility', myChart.HbarChartData.length === 0 ? 'hidden' : 'visible');

      mySvg.select('#chartGroup' + myClass).remove();
      const chartGroup = mySvg.append('g')
        .attr('id', 'chartGroup' + myClass)
        .selectAll('.chartGroup' + myClass)
        .data(groupedData)
        .join((group: any) => {
          const enter = group.append('g').attr('class', 'chartGroup' + myClass);
          // enter.append('rect').attr('class', 'groupRect');
          // enter.append('line').attr('class', 'groupTopLine');
          // enter.append('line').attr('class', 'groupBottomLine');
          // enter.append('text').attr('class', 'groupLabel');
          enter.append('g').attr('class', 'rangeGroup');
          return enter;
        });

      chartGroup.attr('clip-path', 'url(#ghbBrushClip' + myClass + ')');

      // chartGroup.select('.groupLabel')
      //   .attr("font-family", "Poppins")
      //   .attr("font-weight", 700)
      //   .attr("font-size", 12)
      //   .attr("fill", "white")
      //   .attr('text-anchor','middle')
      //   .attr('transform', (d: any) => 'translate('
      //     + (margins.left + margins.brush + margins.mid + 18 + 5)
      //     + ',' + (yScale(d.groupIndex) + margins.top + (groupHeight - margins.group)/2) + ') rotate(-90)')
      //   .text(getGroupLabel)
      //   .on("mouseover", (event:any, d: any) => {
      //     if(getGroupLabel(d).includes("..")){
      //       myChart.showTooltip('groupFullName', d.group.toUpperCase(), event.offsetX, event.offsetY, width);
      //     }
      //   })
      //   .on("mouseout", () => {
      //     myChart.hideTooltip("groupFullName");
      //   });

      // chartGroup.select('.groupTopLine')
      //   .style('stroke-width', 1)
      //   .style('stroke', '#E8EAEE')
      //   .attr('x1', margins.left + margins.brush + margins.mid + 36 + margins.range + 10)
      //   .attr('x2', margins.left + margins.brush + margins.mid + 36)
      //   .attr('y1', (d: any) => yScale(d.groupIndex) + margins.top)
      //   .attr('y2', (d: any) => yScale(d.groupIndex) + margins.top);

      // chartGroup.select('.groupBottomLine')
      //   .style('stroke-width', 1)
      //   .style('stroke', '#E8EAEE')
      //   .attr('x1', margins.left + margins.brush + margins.mid + 36 + margins.range + 10)
      //   .attr('x2', margins.left + margins.brush + margins.mid + 36)
      //   .attr('y1', (d: any) => yScale(d.groupIndex) + margins.top + (groupHeight - margins.group))
      //   .attr('y2', (d: any) => yScale(d.groupIndex) + margins.top + (groupHeight - margins.group));

      // chartGroup.select('.groupRect')
      //   .style('width', 36)
      //   .style('height', groupHeight  - margins.group)
      //   .style('fill', '#8A98AB')
      //   .attr('transform', (d: any) => 'translate(' + (margins.left + margins.brush + margins.mid) + ',' + (yScale(d.groupIndex) + margins.top) + ')');

      chartGroup.select('.rangeGroup')
        .attr('transform', (d: any) => 'translate(' + (margins.left + margins.brush + margins.mid + 36) + ',' + (yScale(d.groupIndex)
          + margins.top + rangeHeight) + ')');

      const rangeGroup = chartGroup
        .select('.rangeGroup')
        .selectAll('.rangeGroup' + myClass)
        .data((d: any) => d.data) // Use the modified data structure
        .join((group: any) => {
          const enter = group.append('g').attr('class', 'rangeGroup' + myClass);
          if (myChart.props.yAxisShow) {
          enter.append('text').attr('class', 'rangeLabel');
        }
          if (myChart.props.navArrow && myChart.props.yAxisShow) {
            enter.append('g').attr('class', 'rangeArrow');
          }
          enter.append('g').attr('class', 'rangeBarGroup')
          enter.append('rect').attr('class', 'rangeMouseoverRect');
          return enter;
        });

      rangeGroup.select(".rangeMouseoverRect")
        .attr("fill", "transparent")
        .attr("width", (d: any) => {
          const maxWidth = xScale(d3.max(d.rangeWithPercentages, (m: any) => m[1])); // Use rangeWithPercentages
          return maxWidth >= 0 ? maxWidth : 0; // Avoid negative width
        })
        .attr("height", rangeHeight + 30)
        .attr('x', margins.range + 24)
        .attr('y', (d: any, i: any) => (i * rangeHeight - 11))
        .on("mousemove", (event: any, d: any) => {
          const tooltipData: any = [];
          d.rangeWithPercentages.forEach((t: any) => { // Use rangeWithPercentages
            tooltipData.push({
              name: t.data.groupVar,
              range: d.range,
              key: t.key,
              value: t.data[t.key],
              fill: myChart.props.barFill[t.key]
            })
          })
          myChart.showTooltip('groupHBar', tooltipData, event.offsetX, event.offsetY, width, height);
        })
        .on('mouseout', () => {
          myChart.hideTooltip('groupHBar');
        });

      rangeGroup.select(".rangeArrow").selectAll('svg').remove();
      rangeGroup.select(".rangeArrow")
        .append('svg')
        .attr('width', 10)
        .attr('height', 10)
        .attr('viewBox', '0 0 8 8')
        .attr('x', margins.range + margins.left - 8)
        .attr("cursor", "pointer")
        .attr('y', (d: any, i: any) => (i * rangeHeight) + (rangeHeight / 2) - 4)
        .append('path')
        .attr('d', 'M0.0127408 0.107494C-0.0132589 0.172532 0.00141278 0.24732 0.0487403 0.297065L3.5977 4.00002L0.0490837 7.70295C0.00141244 7.7527 -0.0129155 7.82817 0.012756 7.89252C0.038412 7.95756 0.0994112 8 0.166739 8L3.1667 8C3.21103 8 3.25337 7.98156 3.2847 7.94921L6.95133 4.12313C6.98366 4.08904 7 4.04453 7 4C7 3.95547 6.98367 3.91096 6.95133 3.87687L3.2847 0.0507881C3.25337 0.0184404 3.21103 6.17196e-07 3.1667 6.15258e-07L0.166739 4.84126e-07C0.0994116 1.66936e-05 0.0384123 0.0424566 0.0127408 0.107494Z')
        .attr('fill', '#1363DF')
        .on("click", (event: any, d: any) => {
          const tooltipData: any = [];
          d.rangeWithPercentages.forEach((t: any) => { // Use rangeWithPercentages
            tooltipData.push({
              group: t.data.groupVar,
              range: d.range,
              key: t.key,
              value: t.data[t.key],
              fill: myChart.props.barFill[t.key],
              AllData: t.data.data[1]
            })
          })
          myChart.NavigationArrow('groupHBar', tooltipData, event.offsetX, event.offsetY, width);
        });

      rangeGroup.select(".rangeLabel")
        // .attr("font-family", "Poppins")
        .attr("font-family", "Poppins")
        .attr("font-weight", myChart.props.yAxisBold ? 700 : 400)
        .attr("font-size", myChart.props.yAxisFontSize)
        .attr("fill", myChart.props.yAxisColor)
        .attr("display", myChart.props.yAxisShow ? "visible" : "hidden")
        .attr("cursor", myChart.props.navArrow ? "pointer" : 'default')
        .attr('text-anchor', 'start')
        .attr('x', -10)
        .attr('y', (d: any, i: any) => (i * rangeHeight) + (rangeHeight / 2) + 6)
        // .text((d: any) => d.range)
        .text(getGroupLabel)
      rangeGroup.select(".rangeLabel").on("click", (event: any, d: any) => {
        if (myChart.props.navArrow) {
          const tooltipData: any = [];
          d.rangeWithPercentages.forEach((t: any) => { // Use rangeWithPercentages
            tooltipData.push({
              group: t.data.groupVar,
              range: d.range,
              key: t.key,
              value: t.data[t.key],
              fill: myChart.props.barFill[t.key],
              AllData: t.data.data[1]
            })
          })
          myChart.NavigationArrow('groupHBar', tooltipData, event.offsetX, event.offsetY, width);
        }
      })
        .on("mouseover", (event: any, d: any) => {
          if (myChart.props.navArrow) {
            d3.select(event.currentTarget).attr("fill", '#1363DF');
          }
          if (getGroupLabel(d).includes("..")) {
            myChart.showTooltip('groupFullName', d.range.toUpperCase(), event.offsetX, event.offsetY, width, height);
          }
        })
        .on("mouseout", (event: any) => {
          if (myChart.props.navArrow) {
            d3.select(event.currentTarget).attr("fill", "#101D42");
          }
          myChart.hideTooltip("groupFullName");
        });

      rangeGroup.select(".rangeBarGroup").attr('clip-path', 'url(#ghbtextClip' + myClass + ')')
        .attr("transform", (d: any, i: any) => "translate(" + (margins.range + 24) + ","
          + (i * (rangeHeight)) + ")")

     const rangeBarGroup = rangeGroup.select(".rangeBarGroup")
  .selectAll('.rangeBarGroup' + myClass)
  .data((d: any) => {
    d.rangeWithPercentages.map((m: any, i: any) => {
      const dataWidth = xScale(m[1]) - xScale(m[0]);
      m.width = dataWidth < 2 && dataWidth !== 0 ? 2 : dataWidth;
      if (dataWidth < 2 && i < (d.rangeWithPercentages.length - 1)) {
        d.rangeWithPercentages.filter((f: any, index: any) => index > i)
          .forEach((m: any) => {
            m.extraX = dataWidth === 0 ? 0 : 2 - dataWidth;
          });
      }
    });

    d.rangeWithPercentages.map((m: any, i: any) =>
      m.borderRadius = i === (d.rangeWithPercentages.length - 1) ? 2 : 0
    );

    return d.rangeWithPercentages;
  })
  .join((group: any) => {
    const enter = group.append('g').attr('class', 'rangeBarGroup' + myClass);
    enter.append('path').attr('class', 'rangeBar');
    enter.append('text').attr('class', 'rangeBarPercentageText');
    mySvg.select('#sliderGroup' + myClass).raise();
    return enter;
  });

if (myChart.props.valueOnBar) {
  // Use groups to potentially add background rectangles later
  const valueOnBarGroup = rangeBarGroup.selectAll('.valueOnBarGroup')
    .data((d: any) => [d]) // Bind the data element itself to the group
    .join('g')
    .attr('class', 'valueOnBarGroup');

  // Determine text content based on type and apply formatting
  // This function calculates the text content and checks if it's valid (non-zero)
  function calculateTextContent(d: any) {
    let content = '';
    if (myChart.props.valueOnBarType === 'value') {
      // Apply decimalPlaces and displayUnits formatting for value
      const displayUnits = myChart.props.valueOnBarDisplayUnits || myChart.props.displayUnits || 'Auto'; // Prefer specific prop, fallback to general
      const decimalPlaces = myChart.props.valueOnBardecimalPlaces !== undefined ? myChart.props.valueOnBardecimalPlaces : myChart.props.decimalPlaces || 0; // Prefer specific prop, fallback to general

      if (displayUnits === 'None') {
        content = d.segmentValue.toFixed(decimalPlaces);
      } else if (displayUnits === 'K') {
        content = (d.segmentValue / 1e3).toFixed(decimalPlaces) + 'K';
      } else if (displayUnits === 'M') {
        content = (d.segmentValue / 1e6).toFixed(decimalPlaces) + 'M';
      } else if (displayUnits === 'B') {
        content = (d.segmentValue / 1e9).toFixed(decimalPlaces) + 'B';
      } else if (displayUnits === 'Auto') {
        const abs = Math.abs(d.segmentValue);
        if (abs >= 1e9) {
          content = (d.segmentValue / 1e9).toFixed(decimalPlaces) + 'B';
        } else if (abs >= 1e6) {
          content = (d.segmentValue / 1e6).toFixed(decimalPlaces) + 'M';
        } else if (abs >= 1e3) {
          content = (d.segmentValue / 1e3).toFixed(decimalPlaces) + 'K';
        } else {
          content = d.segmentValue.toFixed(decimalPlaces);
        }
      }

      // Clean up trailing zeros if needed (optional, but often desired)
      // if (decimalPlaces > 0) {
      //   content = content.replace(/\.?0+([KM B])?$/, '$1');
      // }

    } else if (myChart.props.valueOnBarType === 'percentage') {
      // Apply decimalPlaces formatting for percentage
      const decimalPlaces = myChart.props.valueOnBardecimalPlaces !== undefined ? myChart.props.valueOnBardecimalPlaces : myChart.props.decimalPlaces || 0; // Prefer specific prop, fallback to general
      const formattedPercent = d.percentage.toFixed(decimalPlaces);
      // Clean up trailing zeros if needed (optional)
      // const cleanPercent = decimalPlaces > 0
      //   ? formattedPercent.replace(/\.?0+$/, '')
      //   : formattedPercent;
      content = formattedPercent + '%';
    }
    return content;
  }

  // Calculate the text content for each data point
  valueOnBarGroup.datum((d: any) => {
    const content = calculateTextContent(d);
    // Add the calculated content to the datum object for easy access later
    return { ...d, calculatedTextContent: content };
  });

  // Append the text element
  const valueOnBarText = valueOnBarGroup.append('text')
    .attr('class', 'rangeBarPercentageText') // Keep original class for consistency
    .attr("x", (d: any) => {
      const segmentStart = xScale(d[0]);
      const segmentEnd = xScale(d[1]);
      const segmentWidth = segmentEnd - segmentStart;
      return segmentStart + (segmentWidth / 2);
    })
    .attr("y", (d: any) => {
      if (myChart.props.valueOnBarposition == 'top') {
        return  - 6; // top of the range
      } else if (myChart.props.valueOnBarposition == 'bottom') {
        return rangeHeight + 11; // bottom of the range
      } else { // default = center
        return (rangeHeight / 2) + 4;
      }
    })
    .attr("text-anchor", "middle")
    .attr("dominant-baseline", "middle")
    .attr("fill", myChart.props.valueOnBarColor || (myChart.props.valueOnBarposition == "center" ? "white" : "#101D42")) // Use props.color, fallback to original logic
    .attr("font-size", 10)
    .attr("font-family", "Poppins")
    .attr("font-weight", 400)
    // Set initial text content based on the calculated value
    .text((d: any) => d.calculatedTextContent);

  // Set visibility based on calculated text content and segment width
  valueOnBarText.attr("visibility", (d: any) => {
    // Use the pre-calculated text content
    const textContent = d.calculatedTextContent;
    // Check if text content is valid (not empty, not just whitespace, not evaluating to false)
    const isTextValid = textContent && textContent.trim() !== '';
    // Also check segment width if text is valid
    if (isTextValid) {
      const textWidth = measureTextWidth(textContent, 10, 'Poppins', 400);
      const segmentWidth = xScale(d[1]) - xScale(d[0]);
      return segmentWidth > (textWidth + 4) ? "visible" : "hidden";
    } else {
      return "hidden"; // Hide if text content is invalid/zero
    }
  });

  // Add background rectangle if enabled and text is valid
  if (myChart.props.valueOnBarBackground) {
    const valueOnBarBackground = valueOnBarGroup.insert('rect', '.rangeBarPercentageText') // Insert *before* the text
      .attr('class', 'valueOnBarBackground') // Add a class for styling if needed
      .attr('x', (d: any) => {
        const textContent = d.calculatedTextContent; // Use pre-calculated content
        const textWidth = measureTextWidth(textContent, 10, 'Poppins', 400);
        const segmentStart = xScale(d[0]);
        const segmentEnd = xScale(d[1]);
        const segmentWidth = segmentEnd - segmentStart;
        const textX = segmentStart + (segmentWidth / 2);
        return textX - (textWidth / 2) - 2; // -2 for padding
      })
      .attr('y', (d: any) => {
        if (myChart.props.valueOnBarposition == 'top') {
          const textHeight = 10; // Approximate text height based on font-size
          return  - 4 - textHeight ; // Adjust Y for top position
        } else if (myChart.props.valueOnBarposition == 'bottom') {
          const textHeight = 10; // Approximate text height based on font-size
          return rangeHeight + 11 - (textHeight / 2) - 3; // -2 for padding
        } else { // default = center
          const textHeight = 10; // Approximate text height based on font-size
          return (rangeHeight / 2) + 4 - (textHeight / 2) - 3; // -2 for padding
        }
      })
      .attr('width', (d: any) => {
        const textContent = d.calculatedTextContent; // Use pre-calculated content
        const textWidth = measureTextWidth(textContent, 10, 'Poppins', 400);
        return textWidth + 4; // +4 for padding (2 on each side)
      })
      .attr('height', 10 + 4) // font-size + padding (2 on top, 2 on bottom)
      .attr('fill', myChart.props.valueOnBarBackgroundColor || '#000000')
      .attr('rx', 2) // Rounded corners
      .attr('ry', 2)
      .attr('pointer-events', 'none'); // Allow mouse events to pass through

    // Set background visibility to match the text visibility
    valueOnBarBackground.attr("visibility", (d: any) => {
      const textContent = d.calculatedTextContent; // Use pre-calculated content
      const isTextValid = textContent && textContent.trim() !== '';
      if (isTextValid) {
        const textWidth = measureTextWidth(textContent, 10, 'Poppins', 400);
        const segmentWidth = xScale(d[1]) - xScale(d[0]);
        return segmentWidth > (textWidth + 4) ? "visible" : "hidden";
      } else {
        return "hidden"; // Hide background if text content is invalid/zero
      }
    });
  }

  function measureTextWidth(text: string, fontSize: number, fontFamily: string, fontWeight: number): number {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) return 0;
    ctx.font = `${fontWeight} ${fontSize}px ${fontFamily}`;
    return ctx.measureText(text).width;
  }
}
// --- END OF UPDATED VALUE ON BAR SECTION ---

rangeBarGroup.select(".rangeBar")
  .attr("d", (d: any) =>
    "M0,0 L" +
    (d.width - d.borderRadius) + ",0 Q" + d.width + ",0 " + d.width + "," + d.borderRadius +
    " L " + d.width + "," + (rangeHeight - d.borderRadius + 5) +
    " Q " + d.width + "," + (rangeHeight + 5) + " " + (d.width - d.borderRadius) + "," + (rangeHeight + 5) +
    " L 0," + (rangeHeight + 5) + " Z"
  )
  .attr("transform", (d: any) =>
    "translate(" + (xScale(d[0]) + (d.extraX === undefined ? 0 : d.extraX)) + ",0)"
  )
  .attr("fill", (d: any) => myChart.props.barFill[d.key]);

  if (myChart.props.totalOntop) {
    // Use groups to potentially add background rectangles later
    const totalOnTopGroup = chartGroup.selectAll('.groupTotalGroup')
      .data((d: any) => [d]) // Bind the data element itself to the group
      .join('g')
      .attr('class', 'groupTotalGroup').attr('clip-path', 'url(#tghbtextClip' + myClass + ')');

    // Append the text element
    const totalOnTopText = totalOnTopGroup.append('text')
      .attr('class', 'groupTotalText')
      .attr("x", (d: any) => {
        return margins.left + margins.brush + margins.mid + 38 + margins.range + 24 + xScale(d.totalValue);
      })
      .attr("y", (d: any) => yScale(d.groupIndex) + margins.top + (groupHeight / 2) + 4)
      .attr("text-anchor", "start")
      .attr("dominant-baseline", "middle")
      .attr("font-size", myChart.props.totalLabelFontSize ?? 12)
      .attr("font-family", myChart.props.totalLabelFont ?? "Poppins")
      .attr("font-weight", myChart.props.totalLabelBold ? 700 : 400)
      .attr("fill", myChart.props.totalOnTopColor || myChart.props.totalLabelColor || "#101D42"); // Use props.totalOnTopColor, fallback to old prop or default

    // Determine text content and apply formatting
    totalOnTopText.text((d: any) => {
      // Apply decimalPlaces and displayUnits formatting for the total value
      const displayUnits = myChart.props.displayUnits || 'Auto';
      const decimalPlaces = myChart.props.decimalPlaces !== undefined ? myChart.props.decimalPlaces : 0;
      let formattedTotal = '';

      if (displayUnits === 'None') {
        // No scaling, just format with decimal places
        formattedTotal = d.totalValue.toFixed(decimalPlaces);
      } else if (displayUnits === 'K') {
        formattedTotal = (d.totalValue / 1e3).toFixed(decimalPlaces) + 'K';
      } else if (displayUnits === 'M') {
        formattedTotal = (d.totalValue / 1e6).toFixed(decimalPlaces) + 'M';
      } else if (displayUnits === 'B') {
        formattedTotal = (d.totalValue / 1e9).toFixed(decimalPlaces) + 'B';
      } else if (displayUnits === 'Auto') {
        // Auto scaling logic
        const abs = Math.abs(d.totalValue);
        if (abs >= 1e9) {
          formattedTotal = (d.totalValue / 1e9).toFixed(decimalPlaces) + 'B';
        } else if (abs >= 1e6) {
          formattedTotal = (d.totalValue / 1e6).toFixed(decimalPlaces) + 'M';
        } else if (abs >= 1e3) {
          formattedTotal = (d.totalValue / 1e3).toFixed(decimalPlaces) + 'K';
        } else {
          formattedTotal = d.totalValue.toFixed(decimalPlaces);
        }
      }

      // Remove unnecessary trailing zeros if decimalPlaces > 0
      // if (decimalPlaces > 0) {
      //   formattedTotal = formattedTotal.replace(/\.?0+([KM B])?$/, '$1');
      // }

      return formattedTotal;
    });

    // Add background rectangle if enabled
    if (myChart.props.totalOnTopBackground) {
      totalOnTopText.each(function () {
        //@ts-ignore
        const textEl = this as SVGTextElement;
        const bbox = textEl.getBBox();

        d3.select(textEl.parentNode as SVGGElement)
          .insert('rect', 'text')
          .attr('class', 'groupTotalBackground')
          .attr('x', bbox.x - 2)
          .attr('y', bbox.y - 2)
          .attr('width', bbox.width + 4)
          .attr('height', bbox.height + 4)
          .attr('fill', myChart.props.totalOnTopBackgroundColor || '#FFFFFF')
          .attr('rx', 2)
          .attr('ry', 2)
          .attr('pointer-events', 'none');
      });
    }
  }

    }
   mySvg.select('#sliderGroup' + myClass).remove();

  const slider = mySvg.append('g')
    .attr('id', 'sliderGroup' + myClass);

    // Bar Slider
    if (myChart.props.leftSlider) {
      myChart.barMin = myChart.currentMin;
      myChart.barMax = xMax;
      createRangeSlider('bar', myChart.currentMin, xMax);
    }
    // // Line Slider
    // if(myChart.props.rightSlider){
    // myChart.lineMin = myChart.currentMin;
    // myChart.lineMax = yMax;
    // createRangeSlider('line', myChart.currentMin, yMax);}

    function createRangeSlider(id: string, min: number, max: number): void {
      const xScale: any = d3.scaleLinear().domain([0, xMax]).range([0, chartWidth]);
      const sliderGroupId = `sliderGroup-${id}`;
      const sliderClass = `${id}-slider`;
      // Remove any existing slider group for this ID
      slider.select(`#${sliderGroupId}`).remove();
      // Create a new slider group
      const sliderGroup = slider.append('g').attr('id', sliderGroupId);
      // Scale setup for the slider
      const scale = d3
        .scaleLinear()
        .domain([min, max])
        .range(
          myChart.orientation === 'horizontal'
            ? [0, xScale.range()[1]]
            : [yScale.range()[0], 0]
        )
        .clamp(true);
      // Dynamic transform value based on height
      const transformValue = `translate(${margins.left + margins.brush + margins.range + 40 }, ${
        height - margins.bottom
      })`;
      // Drag event handlers for the min and max handles
      const dragMinHandle = d3
        .drag()
        .on('drag', (event) =>
          onDragMinHandle(sliderGroup, event, scale, sliderClass, id, min, max)
        );
      const dragMaxHandle = d3
        .drag()
        .on('drag', (event) =>
          onDragMaxHandle(sliderGroup, event, scale, sliderClass, id, min, max)
        );
      // Create the slider track and inset line
      sliderGroup
        .append('line')
        .attr('class', `${sliderClass} ${id}-track`)
        .attr(myChart.orientation === 'horizontal' ? 'x1' : 'y1', scale(min))
        .attr(myChart.orientation === 'horizontal' ? 'x2' : 'y2', scale(max))
        .attr('transform', transformValue)
        .attr('stroke', '#ddd')
        .attr('stroke-width', 1);
      sliderGroup
        .append('line')
        .attr('class', `${sliderClass} ${id}-track-inset`)
        .attr(myChart.orientation === 'horizontal' ? 'x1' : 'y1', scale(min))
        .attr(myChart.orientation === 'horizontal' ? 'x2' : 'y2', scale(max))
        .attr('transform', transformValue)
        .attr('stroke', '#ddd')
        .attr('stroke-width', 1);
      // Tooltip setup
      const tooltip = d3
        .select('body')
        .append('div')
        .attr('class', 'tooltip')
        .style('position', 'absolute')
        .style('padding', '5px')
        .style('background', '#fff')
        .style('border', '1px solid #ccc')
        .style('border-radius', '4px')
        .style('pointer-events', 'none')
        .style('opacity', 0);
      // Create Min and Max handles with hover and drag functionality
      createSliderHandle(
        sliderGroup,
        sliderClass,
        id,
        'min', min, scale,
        dragMinHandle,
        tooltip,
        transformValue
      );
      createSliderHandle(
        sliderGroup,
        sliderClass,
        id,
        'max',
        max,
        scale,
        dragMaxHandle,
        tooltip,
        transformValue
      );
    }
    function createSliderHandle(
      sliderGroup: any,
      sliderClass: string,
      id: string,
      handleType: string,
      value: any,
      scale: any,
      dragHandle: any,
      tooltip: any,
      transformValue: string
    ): void {
      const circleColor: string = handleType === 'min' ? '#718EB6' : '#69b3a2';
      const hoverLayer = sliderGroup
        .append('circle')
        .attr('class', `${sliderClass} ${id}-${handleType}-hover-layer`)
        .attr(myChart.orientation === 'horizontal' ? 'cx' : 'cy', scale(value))
        .attr('transform', transformValue)
        .attr('r', myChart.handleRadius + 8)
        .attr('fill', circleColor)
        .attr('opacity', 0)
        .attr('pointer-events', 'none');
      const handle = sliderGroup
        .append('circle')
        .attr('class', `${sliderClass} ${id}-${handleType}-handle`)
        .attr(myChart.orientation === 'horizontal' ? 'cx' : 'cy', scale(value))
        .attr('transform', transformValue)
        .attr('r', myChart.handleRadius)
        .attr('fill', circleColor)
        // Put clicked handle to bottom of DOM group so that it overlaps the other handle
        .on('mousedown', function () {
          handle.raise();
        })
        .call(dragHandle);
      // Handle hover effects
      handle
        .on('mouseover', function () {
          hoverLayer.transition().duration(200).attr('opacity', 0.4);
        })
        .on('mouseout', function () {
          hoverLayer.transition().duration(400).attr('opacity', 0);
        });
    }
    function onDragMinHandle(
      sliderGroup: any,
      event: any,
      scale: any,
      sliderClass: string,
      id: string,
      min: number,
      max: number
    ): void {
      const newPos = Math.max(scale(min), event[myChart.orientation === 'horizontal' ? 'x' : 'y'] - (margins.left + margins.brush + margins.range + 40));
      const currentMin = Math.round(scale.invert(newPos));
      // If our drag is greater than the minimum edge and less than the Max handle
      if (currentMin >= min && currentMin <= (id === 'line' ? myChart.lineMax - 5 : myChart.barMax - 5)) {
        id === 'line' ? myChart.lineMin = currentMin : myChart.barMin = currentMin;
        // update the chart minimum and set the handle to the new position
        updateSliderHandlePosition(sliderGroup, sliderClass, id, 'min', newPos);
        updateTrackInset(sliderGroup, scale, sliderClass, id, currentMin, max);
        drawChart();
      }
      // Our drag is less than the minimum edge of the axis
      else if (currentMin < min) {
        id === 'line' ? myChart.lineMin = min : myChart.barMin = min;
        // Set the handle position to the minimum edge of the axis
        updateSliderHandlePosition(sliderGroup, sliderClass, id, 'min', scale(min));
        updateTrackInset(sliderGroup, scale, sliderClass, id, min, max);
        drawChart();
      }
    }
    function onDragMaxHandle(
      sliderGroup: any,
      event: any,
      scale: any,
      sliderClass: string,
      id: string,
      min: number,
      max: number
    ): void {
      const newPos = Math.min(scale(max), event[myChart.orientation === 'horizontal' ? 'x' : 'y'] - (margins.left + margins.brush + margins.range + 40));
      const currentMax = Math.round(scale.invert(newPos));
      // If our drag is less than the maximum edge and more than the Min handle
      if (currentMax <= max && currentMax >= (id === 'line' ? myChart.lineMin + 5 : myChart.barMin + 5)) {
        id === 'line' ? myChart.lineMax = currentMax : myChart.barMax = currentMax;
        // update the chart maximum and set the handle to the new position
        updateSliderHandlePosition(sliderGroup, sliderClass, id, 'max', newPos);
        updateTrackInset(sliderGroup, scale, sliderClass, id, min, currentMax);
        drawChart();
      }
      // Our drag is more than the maximum edge of the axis
      else if (currentMax > max) {
        id === 'line' ? myChart.lineMax = max : myChart.barMax = max;
        // Set the handle position to the maximum edge of the axis
        updateSliderHandlePosition(sliderGroup, sliderClass, id, 'max', scale(max));
        updateTrackInset(sliderGroup, scale, sliderClass, id, min, max);
        drawChart();
      }
    }
    function updateTrackInset(sliderGroup: any, scale: any, sliderClass: string, id: string, min: number, max: number): void {
      sliderGroup.select(`.${sliderClass}.${id}-track-inset`)
        .attr(myChart.orientation === 'horizontal' ? 'x1' : 'y1', scale(min))
        .attr(myChart.orientation === 'horizontal' ? 'x2' : 'y2', scale(max));
    }
    function updateSliderHandlePosition(sliderGroup: any, sliderClass: string, id: string, handleType: string, newPos: number): void {
      sliderGroup.select(`.${sliderClass}.${id}-${handleType}-handle`)
        .attr(myChart.orientation === 'horizontal' ? 'cx' : 'cy', newPos);
      sliderGroup.select(`.${sliderClass}.${id}-${handleType}-hover-layer`)
        .attr(myChart.orientation === 'horizontal' ? 'cx' : 'cy', newPos);
    }

    function drawLegend(legendData: any) {
      const legendGroup = mySvg
        .select('#legendGroup' + myClass)
        .selectAll('.legendGroup' + myClass)
        .data(legendData)
        .join((group: any) => {
          const enter = group.append('g').attr('class', 'legendGroup' + myClass);
          enter.append('circle').attr('class', 'legendCircle');
          enter.append('text').attr('class', 'legendLabel');
          return enter;
        });

      legendGroup.select('.legendCircle')
        .attr('id', (d: any) => 'circle_legendItem' + (d).replaceAll(' ', '_'))
        .attr('fill', (d: any) => myChart.props.barFill[d])
        .attr('r', 4);
      legendGroup.attr("visibility", myChart.props.legendShow ? "visible" : "hidden");
      legendGroup.select('.legendLabel')
        .attr('id', (d: any) => 'legendItem' + (d).replaceAll(' ', '_'))
        .attr('y', 5)
        .attr('fill', '#101D42')
        .attr('font-weight', '500')
        .attr('font-size', '12')
        .attr('font-family', 'Poppins')
        .text((d: any) => myChart.props.barLabels[d]?.toUpperCase().replace(/_/g, ' '))

      let legendX = 0;
      mySvg.selectAll('.legendLabel').each(function (d: any): any {
        //@ts-ignore
        const myObject = this;
        const myWidth: any = document.getElementById((myObject.id).replaceAll(' ', '_'))?.getBoundingClientRect().width;
        d3.select(myObject).attr('x', legendX + 12);
        mySvg.select('#circle_' + (myObject.id).replaceAll(' ', '_')).attr('cx', legendX);
        legendX += (40 + myWidth)
      });
      legendGroup.attr('transform', 'translate(' + ((width - legendX + 24) / 2) + ',10)');
    }

    function getGroupLabel(d: any): string {
      const maxWidth = margins.range;
      const fontSize = 10 //myChart.props.navArrow ? 11 : (myChart.isFullscreen ? 10 : 8 )// 12;
      const fullText = d.range;
      const ellipsis = "..";
      // If full text fits, return as-is
      if (checkWidth(fullText)) {
        return fullText;
      }
      // Start with binary search to find max fitting length
      let left = 0;
      let right = fullText.length;
      let bestFit = "";
      while (left <= right) {
        const mid = Math.floor((left + right) / 2);
        const candidate = fullText.substring(0, mid).trim() + ellipsis;
        if (checkWidth(candidate)) {
          bestFit = candidate;
          left = mid + 1;
        } else {
          right = mid - 1;
        }
      }
      return bestFit;

      function checkWidth(text: string): boolean {
        return measureWidth(text, fontSize) <= maxWidth;
      }
    }

    function measureWidth(text: string, fontSize: number): number {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      if (!ctx) return 0;
      // Match the real style used in the chart labels
      ctx.font = `700 ${fontSize}px Poppins`; // Adjust '600' or 'bold' as needed
      return ctx.measureText(text).width;
    }

    function brushed(event: any): void {
      const selection = event.selection;
      if (selection !== null) {
        // myChart.hideTooltip('groupHBar');
        // myChart.hideTooltip("groupFullName");
        const yDomain: any = selection.map(yScaleAll.invert);
        if ((yDomain[1] - yDomain[0]) < 0.99) {
          if ((yDomain[0] + 1) > groupSet.length) {
            yDomain[0] = yDomain[1] - 1;
          } else {
            yDomain[1] = yDomain[0] + 1;
          }
          mySvg.select('#brushGroup' + myClass)
            //@ts-ignore
            .call(brush.move, myChart.props.showBrush === false ? null : [yScaleAll(yDomain[0]), yScaleAll(yDomain[1])]);
        } else {
          visibleGroups = ((yDomain[1] - yDomain[0]) / groupSet.length) * groupSet.length;
          yScale.domain(yDomain);
          drawChart();
          const handleSouthY = +mySvg.select('#brushGroup' + myClass).select('.handle--s').attr('y');
          const handleNorthY = +mySvg.select('#brushGroup' + myClass).select('.handle--n').attr('y');
          mySvg.select('.handleLeftLine1' + myClass)
            .attr('y1', handleSouthY + 3)
            .attr('y2', handleSouthY + 3);
          mySvg.select('.handleLeftLine2' + myClass)
            .attr('y1', handleSouthY + 7)
            .attr('y2', handleSouthY + 7);
          mySvg.select('.handleRightLine1' + myClass)
            .attr('y1', handleNorthY + 3)
            .attr('y2', handleNorthY + 3);
          mySvg.select('.handleRightLine2' + myClass)
            .attr('y1', handleNorthY + 7)
            .attr('y2', handleNorthY + 7);
          mySvg.select('#brushGroup' + myClass)
            .selectAll('.handle').raise()
            .attr('fill', 'white')
            .attr('rx', 4)
            .attr('ry', 4)
            .attr('x', (margins.brush - 24) / 2)
            .attr('width', 24)
            .style('filter', 'url(#drop-shadow)');
        }
      }
    }
    this.stop(10).then(() => this.isLoading = false);
    // so now
    // get horizontal brush working with just groups
    // then add bars and range labels?
  }

  // property & data for the chart
  getWordCloudData() {
    let cgf: any = this.item.config
    this.data.forEach((obj: any) => {
      obj.error_type_nm = "defect_count";
      if (this.item.config?.stacked_bar?.value !== 'true') { obj.error_type_code = "D"; }
    });
    const barFill: any = {};
    const barLabels: any = {};
    // Populate the objects dynamically
    cgf?.bar_Fill?.values?.forEach((item: any) => {
      barFill[item.col_value] = item.color;  // Assign the color to barFill
      barLabels[item.col_value] = item?.col_label ? item.col_label : item.col_value;  // Assign the col_value as the label
    });
    this.HbarChartData = this.data;
    this.props = {
      chartHeight: cgf?.designer_chart_height ? Number(cgf?.designer_chart_height) : (cgf?.y_axis_nav?.value === 'true' ? 500 : 500), // Minimum is 300px, depends on the number of groups
      rangeVar: 'error_type_nm',
      stackVar: cgf?.stacked_var?.['api_resp_column_nm'] || 'error_type_code', // Value
      groupVar: cgf?.y_axis?.['api_resp_column_nm'] || 'field_name', // Y-axis
      valueVar: cgf?.x_axis?.['api_resp_column_nm'] || 'defect_count', // X-axis
      xAxisLabel: cgf?.x_axis_label?.toUpperCase() || 'field_name',
      yAxisLabel: cgf?.y_axis_label?.toUpperCase() || 'defect_count',
      barFill: barFill || { 'D': '#9024E7' },
      barLabels: barLabels || { 'D': 'defects' },
      XtickCount: cgf?.y_axis_nav?.value === 'true' ? 11 : 6,
      navArrow: cgf?.y_axis_nav?.value === 'true',
      leftSlider: this.item.config?.['zoom_slider']?.value == 'true' || false,
      xAxisFormatting: '-2~s',
      totalOntop: cgf?.total_on_top?.value === 'true' || false,
      valueOnBar: cgf?.value_on_bar?.value === 'true' || false,
      valueOnBarType: cgf?.value_on_bar_type?.value || 'percentage', // 'value' or 'percentage'
      valueOnBarposition: cgf?.value_on_bar_position?.value || 'center', // 'top' or 'center' or 'bottom'
      // --- ADD THESE NEW PROPERTIES ---
      valueOnBarColor: cgf?.value_on_bar_color?.value || 'white', // Add this config
      valueOnBarBackground: cgf?.value_on_bar_background?.value === 'true' || false, // Add this config
      valueOnBarBackgroundColor: cgf?.value_on_bar_background_color?.value || '#000000', // Add this config
      valueOnBarDisplayUnits: cgf?.value_on_bar_display_units?.value || 'Auto', // Add this config
      valueOnBardecimalPlaces: cgf?.value_on_bar_decimal_places?.value !== undefined ? parseInt(cgf?.value_on_bar_decimal_places?.value, 10) : 0, // Add this config
      totalOnTopColor: cgf?.total_on_top_color?.value || '#101D42', // Add this config
      totalOnTopBackground: cgf?.total_on_top_background?.value === 'true' || false, // Add this config
      totalOnTopBackgroundColor: cgf?.total_on_top_background_color?.value || '#FFFFFF', // Add this config
      displayUnits: cgf?.display_units?.value || 'Auto', // Add this config (fallback for total labels)
      decimalPlaces: cgf?.decimal_places?.value !== undefined ? parseInt(cgf?.decimal_places?.value, 10) : 0, // Add this config (fallback for total labels)
      // --- END ADD ---
      // X-Axis
      xAxisShow: true,
      xAxisFontSize: 12,
      xAxisBold: false,
      xAxisColor: '#101D42',
      // Y-Axis
      yAxisShow: true,
      yAxisFontSize: 12,
      yAxisBold: false,
      yAxisColor: '#101D42',
      // Legend
      legendShow: true,
    };
    // if(cgf?.static_data?.value=='true'){
    // this.props.barFill=  { 'MERGED':'#1363DF' ,'UNMERGED':'#8C23E6' , 'NET NEW':'#2ED67B', }
    // this.props.barLabels= { 'MERGED':'MERGED' ,'UNMERGED':'UNMERGED' , 'NET NEW':'NET NEW',}
    // } 
    // @ts-ignore
   if (this.HbarChartData.length > 0) {
        this.noData = true;
        setTimeout(() => {
          if (Object.keys(this.prefrenceConfig || {}).length > 0) {
            this.applyChartPreferences(this.prefrenceConfig);
          } else {
            this.plotChart();
          }
        }, 50);
      } else {
        this.noDataNotifier.report('horizontal-bar-chart');

        this.isLoading = false;
        this.noData = false;
      }
  }

  applyChartPreferences(event: any) {
    if (event) {
      // ----- X-Axis -----
      this.props.xAxisShow = event.xAxis.show;
      this.props.xAxisFontSize = event.xAxis.fontSize;
      this.props.xAxisBold = event.xAxis.bold;
      this.props.xAxisColor = event.xAxis.color;
      // ----- Y-Axis -----
      this.props.yAxisShow = event.yAxis.show;
      this.props.yAxisFontSize = event.yAxis.fontSize;
      this.props.yAxisBold = event.yAxis.bold;
      this.props.yAxisColor = event.yAxis.color;
      // ----- Legend -----
      this.props.legendShow = event.legend.show;
      this.props.legendFontSize = event.legend.fontSize;
      this.props.legendColor = event.legend.color;
      this.props.legendPosition = event.legend.position;
      // ----- Data Labels -----
      this.props.valueOnBar = event.dataLabels.enabled;
      this.props.valueOnBarColor = event.dataLabels.textColor; // Use the specific property from event
      this.props.valueOnBarType = event.dataLabels.valueOnBarType;
      this.props.valueOnBarposition = event.dataLabels.position;
      this.props.valueOnBarBackground = event.dataLabels.background; // Use the specific property from event
      this.props.valueOnBarBackgroundColor = event.dataLabels.backgroundColor; // Use the specific property from event
      this.props.valueOnBarDisplayUnits = event.dataLabels.displayUnits; // Use the specific property from event
      this.props.valueOnBardecimalPlaces = event.dataLabels.decimalPlaces; // Use the specific property from event
      // ----- Total Labels -----
      this.props.totalOntop = event.totalLabels.enabled;
      this.props.totalOnTopColor = event.totalLabels.color; // Use the specific property from event
      this.props.totalOnTopBackground = event.totalLabels.background; // Use the specific property from event
      this.props.totalOnTopBackgroundColor = event.totalLabels.backgroundColor; // Use the specific property from event
      this.props.displayUnits = event.totalLabels.displayUnits; // Use the specific property from event
      this.props.decimalPlaces = event.totalLabels.decimalPlaces; // Use the specific property from event
      // ----- Zoom Slider -----
      this.props.leftSlider = event.zoomSlider.show;
    }
    // redraw chart
    setTimeout(() => {
      this.plotChart();
    }, 50);
  }

  
}